export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const APP_ENVIRONMENT_NORMALIZED = APP_ENVIRONMENT?.toLowerCase();
export const IS_DEBUG_MODE = process.env.NODE_ENV === "development";

export const IS_LOCAL_ENVIRONMENT = APP_ENVIRONMENT_NORMALIZED === "local";
export const IS_DEVELOPMENT_ENVIRONMENT = IS_DEBUG_MODE;
export const IS_TEST_ENVIRONMENT = APP_ENVIRONMENT_NORMALIZED === "test";
export const IS_PRODUCTION_ENVIRONMENT =
  APP_ENVIRONMENT_NORMALIZED === "production";

export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_ADMIN = process.env.REACT_APP_API_URL_ADMIN;
export const HUBS_URL = `${API_URL}/hubs`;

export const COGNITO_USER_POOL_CLIENT_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID ??
  "44ltcmhf7r8cti7u2fanuvk2tm";
export const COGNITO_USER_POOL_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_ID ?? "us-east-1_1mePE2aSS";

export const DEFAULT_FACILITY_KEY =
  process.env.REACT_APP_COORD_DEFAULT_FACILITY_KEY;

export const AUTO_LOGOUT_SECONDS = process.env.REACT_APP_AUTO_LOGOUT_SECONDS
  ? Number(process.env.REACT_APP_AUTO_LOGOUT_SECONDS)
  : 1800;

export const IS_INACTIVITY_LOGOUT_DISABLED = IS_DEVELOPMENT_ENVIRONMENT;
